
































































































/** @format */

import { Vue, Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
import GoBackWithCloseTabMixin from '@/common/mixins/go-back-with-close-tab';
import moment from 'moment';
import { GANG_STOP_PERSON } from '../router-names';
// import { debounce } from 'lodash'
import * as _ from 'lodash';
import Utils from '@root/utils/common';
// axios请求 ???????
// import { detailsentryList } from '@/api/parking-lot-management/index'

@Component
// @Component
export default class GangStopDetail extends Mixins(TableMixin, TableWidthMixin, GoBackWithCloseTabMixin) {
  path = '/smart-parking/parking-lot-management/gang-stop-person';

  sentryList = {};

  id = '';
  headTitle = '当班记录';
  tableData = [];

  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '岗亭账号信息',
        location: {
          name: GANG_STOP_PERSON
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  created() {
    console.log(this.$route.params.id);
    this.id = this.$route.params.id;
    this.renderDetail(this.$route.params.id);
  }

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '当班时间',
        dataIndex: 'realName',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '应收金额/元',
        dataIndex: 'parkName',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '优惠金额/元',
        dataIndex: 'username',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '实收金额/元',
        dataIndex: 'sex',
        width: 160,
        customRender: (text: any) => text || '--'
        // customRender: (text: string) => dictChannelTypeMap[text],
      },
      {
        title: '电子支付金额/元',
        dataIndex: 'mobile',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '现金金额/元',
        dataIndex: 'enabled',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '应收未收金额/元',
        dataIndex: 'enabled3',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '结算状态',
        dataIndex: 'enabled1',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '结算时间',
        dataIndex: 'enabled2',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '接班人',
        dataIndex: 'createTime',
        width: 160,
        customRender: (text: any) => text || '--'
      }
    ];
  }

  async renderDetail(id: string) {
    // try {
    //   const { data, status, code, msg } = await detailsentryList({ id })
    //   console.log(data)
    //   this.sentryList = data
    // } catch (error) {
    //   console.log(error)
    // }
  }
  onSearch() {}
  sentryListFormtop = [
    {
      prop: 'realName',
      label: '姓名 ：'
    },
    {
      prop: 'sex',
      label: '性别 ：'
    },
    {
      prop: 'age',
      label: '年龄 ：'
    },
    {
      prop: 'fromAreaName',
      label: '收费员类型 ：'
    },
    {
      prop: 'toAreaName',
      label: '上岗日期 ：'
    },
    {
      prop: 'mobile',
      label: '联系电话 ：'
    }
  ];
  // // 返回
  // goBack() {
  //   this.$router.replace({
  //     name: GANG_STOP_PERSON,
  //   })
  // }
}
